export const ALIGNS = [undefined, 'left', 'center', 'right'] as const;

export const TRANSFORMS = [
	undefined,
	'capitalize',
	'full-size-kana',
	'full-width',
	'lowercase',
	'none',
	'uppercase',
] as const;

export const FONT_WEIGHTS = [
	undefined,
	100,
	200,
	300,
	400,
	500,
	600,
	700,
	800,
] as const;

export const COLORS = [
	undefined,
	'semi-transparent',
	'warn',
	'white',
	'grey-52-solid',
	'grey-85-solid',
	'grey-68-solid',
	'grey-95-solid',
	'rose-48-solid',
	'rose-58-solid',
	'white-l',
	'white-s',
	'grey-6-solid',
	'black-m',
] as const;

export const COLORS_MAP = {
	'semi-transparent': 'var(--color-grey-68-solid)',
	'grey-6-solid': 'var(--color-grey-6-solid)',
	'grey-52-solid': 'var(--color-grey-52-solid)',
	'grey-85-solid': 'var(--color-grey-85-solid)',
	'grey-68-solid': 'var(--color-grey-68-solid)',
	'grey-95-solid': 'var(--color-grey-95-solid)',
	'rose-48-solid': 'var(--color-rose-48-solid)',
	'rose-58-solid': 'var(--color-rose-58-solid)',
	warn: 'var(--color-error)',
	// default value is inherit, sometimes we need to override it
	white: 'var(--color-white-solid)',
	'white-l': 'var(--color-white-l)',
	'white-s': 'var(--color-white-s)',
	'black-m': `var(--color-black-m)`,
};

export type TAlign = (typeof ALIGNS)[number];
export type TTextTransform = (typeof TRANSFORMS)[number];
export type TFontWeight = (typeof FONT_WEIGHTS)[number];
export type TColor = (typeof COLORS)[number];

export type CommonProps<TSize> = {
	align?: TAlign;
	size?: TSize;
	multiline?: boolean;
	capitalizeFirstLetter?: boolean;
	fontWeight?: TFontWeight;
	transform?: TTextTransform;
	color?: TColor;
};
